import { isAuthenticated } from "@utils/auth";
import { useCallback, useMemo } from "react";
import { KeycloakAuthContext } from "./keycloakAuthContext";

/** Legacy mode: no Keycloak; same {@link useKeycloakAuth} contract as Keycloak provider. */
export function LegacyAuthProvider({ children }) {
  const ensureAuthenticated = useCallback(async (options = {}) => {
    if (isAuthenticated()) {
      return true;
    }
    return options.redirectIfUnauthenticated === false;
  }, []);

  const value = useMemo(
    () => ({
      ready: true,
      keycloak: null,
      loginWithKeycloak: async () => {},
      ensureAuthenticated,
    }),
    [ensureAuthenticated],
  );

  return <KeycloakAuthContext.Provider value={value}>{children}</KeycloakAuthContext.Provider>;
}
